import { FC, memo, useMemo } from 'react';
import { useController } from 'react-hook-form';

import FormControl from '@material-ui/core/FormControl';

import { HelperTxt } from '../helperTxt/HelperTxt';
import { TimeInput } from '../timeInput/TimeInput';
import { TimeInputProps } from '../timeInput/TimeInput.types';
import { FormItem } from './FormItems.types';

export const FormTimeInput: FC<FormItem & { size?: TimeInputProps['size'] }> = memo(({ control, name, ...rest }) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: undefined,
  });

  const helperText = useMemo(() => {
    if (error) {
      return error.message;
    }

    return '';
  }, [error]);

  return (
    <FormControl error={!!error}>
      <TimeInput {...rest} {...field} error={!!error} />

      {helperText && <HelperTxt>{helperText}</HelperTxt>}
    </FormControl>
  );
});
